import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';
import { Bell, Check, X } from 'lucide-react';
import toast from 'react-hot-toast';

export default function SinoNotificacoes() {
  const [convites, setConvites] = useState([]);
  const [naoLidos, setNaoLidos] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const fetchNotificacoes = async () => {
    try {
      const { data } = await api.get('/clinica/notificacoes');
      setConvites(data.data);
      setNaoLidos(data.naoLidos);
    } catch {}
  };

  useEffect(() => {
    fetchNotificacoes();
    const interval = setInterval(fetchNotificacoes, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOpen = async () => {
    setOpen(o => !o);
    if (!open && naoLidos > 0) {
      try {
        await api.patch('/clinica/notificacoes/lidas');
        setNaoLidos(0);
      } catch {}
    }
  };

  const responder = async (conviteId, status) => {
    try {
      await api.patch(`/clinica/convites/${conviteId}`, { status });
      toast.success(status === 'aceito' ? 'Convite aceito!' : 'Convite recusado.');
      setConvites(c => c.filter(cv => cv._id !== conviteId));
    } catch {
      toast.error('Erro ao responder convite.');
    }
  };

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={handleOpen}
        className="relative p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
      >
        <Bell className="w-5 h-5" />
        {naoLidos > 0 && (
          <span className="absolute top-1 right-1 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center leading-none">
            {naoLidos}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-2xl shadow-lg border border-gray-100 z-50 overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100">
            <p className="text-sm font-semibold text-gray-800">Convites de Clínicas</p>
          </div>

          {convites.length === 0 ? (
            <p className="text-sm text-gray-500 text-center py-8">Nenhum convite pendente</p>
          ) : (
            <div className="divide-y divide-gray-50 max-h-80 overflow-y-auto">
              {convites.map(cv => (
                <div key={cv._id} className="p-4">
                  <p className="text-sm font-medium text-gray-800">{cv.clinica?.nome}</p>
                  {cv.clinica?.telefone && (
                    <p className="text-xs text-gray-500 mt-0.5">{cv.clinica.telefone}</p>
                  )}
                  <div className="flex gap-2 mt-3">
                    <button
                      onClick={() => responder(cv._id, 'aceito')}
                      className="flex items-center gap-1 px-3 py-1.5 bg-green-500 hover:bg-green-600 text-white text-xs rounded-lg font-medium transition-colors"
                    >
                      <Check className="w-3 h-3" /> Aceitar
                    </button>
                    <button
                      onClick={() => responder(cv._id, 'recusado')}
                      className="flex items-center gap-1 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 text-xs rounded-lg font-medium transition-colors"
                    >
                      <X className="w-3 h-3" /> Recusar
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}